// ==================================================================
// スクロールでヘッダー表示・非表示
// ==================================================================
const header = document.querySelector('.gHeadArea');
let startPos = 0,
	scrollPos = 0;

const headerScroll = () => {
	scrollPos = window.scrollY; // スクロール量はスクロールした分
	if (scrollPos >= startPos) { // スクロール量が0以上の時
		header.classList.add('gHeadArea-isActive');
	} else {
		header.classList.remove('gHeadArea-isActive');
	}
	startPos = scrollPos; // 現在の位置を更新
}

window.addEventListener('scroll', headerScroll); // スクロールしたら、headerScrollの処理が発動

//以下無名関数

// const header = document.querySelector('.gHeadArea');
// let startPos = 0,
// 	scrollPos = 0;

// window.addEventListener('scroll', () => { // スクロールしたら
// 	scrollPos = window.scrollY; // スクロール量はスクロールした分
// 	if (scrollPos >= startPos) { // スクロール量が0以上の時
// 		header.classList.add('gHeadArea-isActive');
// 	} else {
// 		header.classList.remove('gHeadArea-isActive');
// 	}
// 	startPos = scrollPos; // 現在の位置を更新
// });


// ==================================================================
// ダウンメニューがあるものをホバーしたときの動き
// ==================================================================
$(function(){

	// pc
	$(".gHeader_item-down").hover(function(){ // hoverしたら下層メニューが出現
		if(window.innerWidth <= 737) { return }
		$(this).toggleClass("gHeader_item-isActive");
	});

	// sp
	$(".gHeader_item-down").click(function(){
		if(window.innerWidth >= 736) { return }
		$(this).toggleClass("gHeader_item-isActive");
	});

});

// ==================================================================
// gHeader_navBtnの開閉
// ==================================================================
$(function(){
	$('.gHeader_navBtn').on('click', function(){
		toggle();
	});
});

const open = function() { // gHeader_navBtnを開ける動き
	$('.gHeader_navBtn').addClass('gHeader_navBtn-isActive');
	$('.gHeader_nav').addClass('gHeader_nav-isActive');
	$('.gHeadArea').addClass('gHeadArea-isActiveStop');
}

const close = function() { // gHeader_navBtnを閉める動き
	$('.gHeader_navBtn').removeClass('gHeader_navBtn-isActive');
	$('.gHeader_nav').removeClass('gHeader_nav-isActive');
	$('.gHeadArea').removeClass('gHeadArea-isActiveStop');
}

const toggle = function(){ // gHeader_navBtnを開け閉めする動き
	$('.gHeader_navBtn').hasClass('gHeader_navBtn-isActive') ? close() : open(); // .gHeader_btn が .gHeader_btn-isActive を持っていたら外す。持っていなかったらつける。
	// 条件式 ? 条件式がtrueの時の処理 : 条件式がfalseの時の処理;
}

module.exports = { // 定義した関数を他ファイルで使えるようにする
	open,
	close,
	toggle
};